import React, { useEffect, useState } from "react";
import ThemeButton from "./theme-button";
import ProfileInfo from "./profile-info";
import VerticalHeader from "./vertical-header";
import HorizontalHeader from "./horizontal-header";
import Inbox from "./inbox";
import HorizontalMenu from "./horizontal-menu";
import NotificationMessage from "./notification-message";
import MobileMenuHandler from "./mobile-menu-handler";
import ClassicHeader from "./layout/classic-header";
import FullScreen from "./full-screen";
import { cn } from "../../../helper/utilityHelper";
import { useSidebar, useThemeStore } from "../../../store";
import { useMediaQuery } from "../../../hooks/useMediaQuery";
import { AppSearchSelect, AppSelect } from "../../../components/appComponents";
import common from "../../../helper/common";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../../contexts/auth/authContext";
import { useQueryParams } from "../../../contexts/queryParamsContext";
import { loader } from "react-global-loader";
import { UserTypeEnum } from "../../../constants/appConstant";

const NavTools = ({ isDesktop, isMobile, sidebarType }) => {
  const [myClubs, setMyClubs] = useState([]);
  const [myClubId, setMyClubId] = useState();
  const { params, setParams } = useQueryParams();

  const navigate = useNavigate();
  const location = useLocation();
  const { user: authUser } = useAuth();

  useEffect(() => {
    global.myClub = authUser.myClubs.find((item) => item.id === myClubId);

    setParams({
      ...params,
      myClub: global.myClub,
    });
  }, [myClubId]);

  useEffect(() => {
    (async () => {
      // Try auth context user first, then global.user, then session storage
      let userToUse = authUser;

      // Add null checks to prevent errors in local development
      if (userToUse && userToUse.myClubs && userToUse.defaultClubId) {
        setMyClubs(userToUse.myClubs);
        setMyClubId(userToUse.defaultClubId);

        // Ensure global.user is set
        if (!global.user) {
          global.user = userToUse;
        }

        global.myClub = userToUse.myClubs.find(
          (item) => item.id === userToUse.defaultClubId
        );

        setParams({
          ...params,
          myClub: global.myClub,
        });
      } else {
        // Try to get user from session storage as final fallback
        // const sessionUser = common.getUser();
        // if (sessionUser && sessionUser.myClubs) {
        //   setMyClubs(sessionUser.myClubs);
        //   if (sessionUser.defaultClubId) {
        //     setMyClubId(sessionUser.defaultClubId);
        //   }
        //   global.user = sessionUser;
        // }
      }
    })();
  }, [authUser]);

  // // Retry mechanism for local development
  // useEffect(() => {
  //   if (!myClubs || myClubs.length === 0) {
  //     const retryInterval = setInterval(() => {
  //       const user = authUser || global.user || common.getUser();
  //       if (user && user.myClubs && user.myClubs.length > 0) {
  //         setMyClubs(user.myClubs);
  //         if (user.defaultClubId) {
  //           setMyClubId(user.defaultClubId);
  //         }
  //         if (!global.user) {
  //           global.user = user;
  //         }
  //         clearInterval(retryInterval);
  //       }
  //     }, 1000);

  //     // Clear interval after 10 seconds to avoid infinite retries
  //     setTimeout(() => {
  //       clearInterval(retryInterval);
  //     }, 10000);

  //     return () => clearInterval(retryInterval);
  //   }
  // }, [myClubs, authUser]);

  useEffect(() => {
    if (global.user && myClubId) {
      const updatedUser = {
        ...global.user,
        roleName: global.user?.roleName,
        defaultClubId: myClubId,
      };
      common.setUser(updatedUser);
      // getMenuConfig(updatedUser.roleId);
    }
  }, [myClubId]);

  const onClubChange = async (id) => {
    let resp = await common.ApiService.getInstance().request(
      `ChangeDefaultClub?clubId=${id}`,
      {},
      "POST"
    );    
    // Update global user with new clubId, menus and rolename
    const updatedRoleName = resp?.data?.roleName || global.user?.roleName;
    let updatedMenus = resp?.data?.menus || global.user?.menus || [];

    // Push user profile menu to all users
    if (updatedMenus && updatedMenus.length > 0) {
      const profileMenu = {
        id: 116,
        name: "Edit Profile",
        endpoint: "/app/editprofile",
        parentId: null,
        parentname: null,
        action: null,
        children: [],
        controller: null,
        icon: "Graph",
        icontype: 0,
        isActive: true,
        isclubspecific: true,
        isdefaultview: false,
        isdisplayon: false,
        ispremium: false,
        menutab: null,
        menutabid: null,
        premiumallowed: null,
        sortOrder: 1,
        type: 0,
        user: global.user?.id
      };
      updatedMenus.push(profileMenu);
    }

    const updatedUser = {
      ...global.user,
      roleName: updatedRoleName,
      defaultClubId: id,
      menus: updatedMenus,
    };
    common.setUser(updatedUser);

    common.SweetAlert.alert(resp.message, "success");

    const defaultMenu = updatedUser.menus?.find((menu) => menu.isdefaultview === true);
    const defaultRoute = defaultMenu?.endpoint || "/app/dashboard";
    setTimeout(() => {
      // if (location.pathname === "/app/dashboard") {
      //   window.location.reload();
      // } else {
      //   navigate("/app/dashboard");
      //   window.location.reload();
      // }
      loader.show();
      navigate(defaultRoute);
      window.location.reload();
      loader.hide();
    }, 100);
  };

  return (
    <div className="nav-tools flex items-center  gap-2">
      {/* <div className="md:grid md:grid-cols-4 gap-3 space-y-6 mb-5"> */}
      {global.user?.userType === UserTypeEnum.Club_Specific && (myClubId || (myClubs && myClubs.length > 0)) && (
        <div className="flex flex-col gap-3">
          <AppSearchSelect
            placeholder={"Select Club"}
            data={myClubs}
            value={myClubId}
            className={"w-300"}
            onChange={(e) => onClubChange(e)}
          />
        </div>
      )}
      {/* </div> */}
      {/* {isDesktop && <Language />} */}
      {isDesktop && <FullScreen />}
      {/* <ThemeButton /> */}
      {/* <Inbox /> */}
      {/* <NotificationMessage /> */}
      <div className=" pl-2">
        <ProfileInfo />
      </div>
      <div></div>
      {!isDesktop && sidebarType !== "module" && <MobileMenuHandler />}
    </div>
  );
};

const Header = ({ handleOpenSearch }) => {
  const { collapsed, sidebarType, setCollapsed, subMenu, setSidebarType } =
    useSidebar();
  const { layout, navbarType, setLayout } = useThemeStore();

  const isDesktop = useMediaQuery("(min-width: 1280px)");

  const isMobile = useMediaQuery("(min-width: 768px)");

  // set header style to classic if isDesktop
  React.useEffect(() => {
    if (!isDesktop && layout === "horizontal") {
      setSidebarType("classic");
    }
  }, [isDesktop]);

  // if horizontal layout
  if (layout === "horizontal" && navbarType !== "hidden") {
    return (
      <ClassicHeader
        className={cn(" ", {
          "sticky top-0 z-50": navbarType === "sticky",
        })}
      >
        <div className="w-full bg-card/90 backdrop-blur-lg md:px-6 px-[15px] py-3 border-b">
          <div className="flex justify-between items-center h-full">
            <HorizontalHeader handleOpenSearch={handleOpenSearch} />
            <NavTools
              isDesktop={isDesktop}
              isMobile={isMobile}
              sidebarType={sidebarType}
            />
          </div>
        </div>
        {isDesktop && (
          <div className=" bg-card bg-card/90 backdrop-blur-lg  w-full px-6  shadow-md">
            <HorizontalMenu />
          </div>
        )}
      </ClassicHeader>
    );
  }
  if (layout === "semibox" && navbarType !== "hidden") {
    return (
      <ClassicHeader
        className={cn("  has-sticky-header rounded-md   ", {
          "xl:ml-[72px]": collapsed,
          "xl:ml-[272px]": !collapsed,
          "sticky top-6": navbarType === "sticky",
        })}
      >
        <div className={cn("xl:mx-20 mx-4")}>
          <div className="w-full bg-card/90 backdrop-blur-lg md:px-6 px-[15px] py-3 rounded-md my-6 shadow-md border-b">
            <div className="flex justify-between items-center h-full">
              <VerticalHeader
                sidebarType={sidebarType}
                handleOpenSearch={handleOpenSearch}
              />
              <NavTools
                isDesktop={isDesktop}
                isMobile={isMobile}
                sidebarType={sidebarType}
              />
            </div>
          </div>
        </div>
      </ClassicHeader>
    );
  }
  if (
    sidebarType !== "module" &&
    navbarType !== "floating" &&
    navbarType !== "hidden"
  ) {
    return (
      <ClassicHeader
        className={cn("", {
          "xl:ml-[248px]": !collapsed,
          "xl:ml-[72px]": collapsed,
          "sticky top-0": navbarType === "sticky",
        })}
      >
        <div className="w-full bg-card/90 backdrop-blur-lg md:px-6 px-[15px] py-3 border-b">
          <div className="flex justify-between items-center h-full ">
            <VerticalHeader
              sidebarType={sidebarType}
              handleOpenSearch={handleOpenSearch}
            />
            <NavTools
              isDesktop={isDesktop}
              isMobile={isMobile}
              sidebarType={sidebarType}
            />
          </div>
        </div>
      </ClassicHeader>
    );
  }
  if (navbarType === "hidden") {
    return null;
  }
  if (navbarType === "floating") {
    return (
      <ClassicHeader
        className={cn("  has-sticky-header rounded-md sticky top-6  px-6  ", {
          "ml-[72px]": collapsed,
          "xl:ml-[300px] ": !collapsed && sidebarType === "module",
          "xl:ml-[248px] ": !collapsed && sidebarType !== "module",
        })}
      >
        <div className="w-full bg-card/90 backdrop-blur-lg md:px-6 px-[15px] py-3 rounded-md my-6 shadow-md border-b">
          <div className="flex justify-between items-center h-full">
            <VerticalHeader
              sidebarType={sidebarType}
              handleOpenSearch={handleOpenSearch}
            />
            <NavTools
              isDesktop={isDesktop}
              isMobile={isMobile}
              sidebarType={sidebarType}
            />
          </div>
        </div>
      </ClassicHeader>
    );
  }

  return (
    <ClassicHeader
      className={cn("", {
        "xl:ml-[300px]": !collapsed,
        "xl:ml-[72px]": collapsed,
        "sticky top-0": navbarType === "sticky",
      })}
    >
      <div className="w-full bg-card/90 backdrop-blur-lg md:px-6 px-[15px] py-3 border-b">
        <div className="flex justify-between items-center h-full">
          <VerticalHeader
            sidebarType={sidebarType}
            handleOpenSearch={handleOpenSearch}
          />
          <NavTools
            isDesktop={isDesktop}
            isMobile={isMobile}
            sidebarType={sidebarType}
          />
        </div>
      </div>
    </ClassicHeader>
  );
};

export default Header;
